<template>
    <div class="qtd-stepper" @click.stop>
        <v-btn
            icon
            :disabled="disabled || quantidade <= 0"
            @click.stop="$emit('decrement')"
        >
            <v-icon>mdi-minus</v-icon>
        </v-btn>

        <input
            v-if="editable"
            ref="input"
            class="qtd-input"
            :class="isDark ? 'qtd-input--dark' : 'qtd-input--light'"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="off"
            title="Toque para digitar a quantidade"
            :maxlength="+maxDigits"
            :value="displayValue"
            :disabled="disabled"
            :aria-label="label"
            @click.stop
            @focus="onFocus"
            @keypress="onKeypress"
            @input="onInput"
            @blur="onBlur"
            @keydown.enter.prevent="commit()"
            @keydown.esc.prevent="cancel()"
        >
        <b v-else class="qtd-text">{{ quantidade }}</b>

        <v-btn
            icon
            :disabled="disabled || !canIncrement"
            @click.stop="$emit('increment')"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'QuantidadeStepper',

    props: {
        value: {
            type: [ Number, String ],
            default: 0,
        },

        canIncrement: {
            type: Boolean,
            default: true,
        },

        editable: {
            type: Boolean,
            default: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        maxDigits: {
            type: [ Number, String ],
            default: 4,
        },

        label: {
            type: String,
            default: 'Quantidade',
        },
    },

    data: () => ({
        draft: '',
        focused: false,
    }),

    computed: {
        isDark() {
            return this.$vuetify.theme.isDark;
        },

        quantidade() {
            return +this.value || 0;
        },

        displayValue() {
            return this.focused ? this.draft : this.quantidade;
        },
    },

    methods: {
        onFocus(e) {
            this.draft = String(this.quantidade);
            this.focused = true;

            //Seleciona tudo para que digitar substitua a quantidade atual
            this.$nextTick(() => e.target.select());
        },

        onKeypress(e) {
            //Impede o caractere não numérico de entrar no campo
            e.key?.length === 1 && !/\d/.test(e.key) && e.preventDefault();
        },

        onInput(e) {
            const digits = e.target.value.replace(/\D/g, '').slice(0, +this.maxDigits);

            this.draft = digits;

            //Rede de segurança para colar/autocompletar: corrige o campo após o patch do Vue
            e.target.value !== digits && this.$nextTick(() => {
                this.$refs.input && (this.$refs.input.value = this.draft);
            });
        },

        onBlur() {
            this.focused = false;

            const qtd = +this.draft || 0;

            qtd !== this.quantidade && this.$emit('change', qtd);
        },

        commit() {
            this.$refs.input.blur();
        },

        cancel() {
            this.draft = String(this.quantidade);
            this.focused = false;
            this.$refs.input.blur();
        },
    },
}
</script>

<style scoped>
.qtd-stepper {
    display: inline-flex;
    align-items: center;
}

.qtd-text {
    display: inline-block;
    min-width: 44px;
    text-align: center;
}

.qtd-input {
    width: 44px;
    padding: 2px 0;
    border: none;
    border-bottom: 1px dashed;
    border-radius: 4px 4px 0 0;
    background-color: transparent;
    color: inherit;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    cursor: text;
    outline: none;
    transition: background-color .15s, border-color .15s;
}

.qtd-input--light {
    border-bottom-color: rgba(0, 0, 0, .35);
}

.qtd-input--dark {
    border-bottom-color: rgba(255, 255, 255, .45);
}

.qtd-input:hover:not(:disabled) {
    background-color: rgba(127, 127, 127, .12);
}

.qtd-input:focus {
    border-bottom-style: solid;
    border-bottom-color: var(--v-primary-base, currentColor);
    background-color: rgba(127, 127, 127, .16);
}

.qtd-input:disabled {
    cursor: default;
    opacity: .5;
}
</style>
